import React from "react";
import { animated } from "react-spring";

// when you add the "native" prop to a react-spring components
// You need to interpolate the value to actually use it
export const Clipper = ({
  progress,
  inverted,
  vertical,
  children,
  style,
  ...props
}) => {
  let property = vertical ? "translateY" : "translateX";
  let direction = inverted ? 1 : -1;
  // Parent moves to one direction, children moves to the other side
  return (
    <animated.div
      style={{
        overflow: "hidden",
        height: "100%",
        transform: progress.interpolate(progressVal => {
          return `${property}(${direction * progressVal * 100}%)`;
        }),
        backfaceVisibility: "hidden",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        ...style
      }}
      {...props}
    >
      <animated.div
        style={{
          height: "100%",
          transform: progress.interpolate(
            progressVal => `${property}(${-direction * progressVal * 100}%)`
          ),
          backfaceVisibility: "hidden"
        }}
      >
        {children}
      </animated.div>
    </animated.div>
  );
};
Clipper.defaultProps = {
  progress: 0,
  inverted: false,
  vertical: false
};
